"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHandleSuggestItemClick = void 0;
var _ = require("../../../..");
var _types = require("../../../../actions/filters/types");
var _useActions = require("../useActions");
var _useAnalytics = require("../useAnalytics");
var _reactRedux = require("react-redux");
var _selectors = require("../../../../selectors");
/**
 * Обработчик клика по итему в геосаджесте (список предложенных адресов)
 * Принимает
 *   * errorMessage - ошибка в фильтрах в поле address
 *   * timerId - ID таймера, по которому будет отправляться аналитика, задан
 * */
const useHandleSuggestItemClick = (errorMessage, timerId) => {
  const {
    address,
    estimationTarget
  } = (0, _reactRedux.useSelector)(_selectors.selectFilters);
  const {
    setError,
    setAddress,
    getFlatAreasSuggest,
    setNewbuildingId,
    setFlatNumber,
    setArea,
    setRooms
  } = (0, _useActions.useActions)();
  const {
    trackAddressPick
  } = (0, _useAnalytics.useAnalytics)();
  return params => {
    /** Очищается таймаут, который задается в useAddressProps для аналитики */
    clearTimeout(timerId);

    /** если есть ошибка, она сбросится */
    if (errorMessage) {
      setError({
        currentErrorField: _types.ECurrentErrorField.none,
        errorText: ''
      });
    }
    trackAddressPick(address, params.title, estimationTarget);
    setAddress({
      address: params.title
    });

    /* istanbul ignore else */
    if (estimationTarget === _.EEstimationTargets.flat) {
      /** Отчищаем предзаполненные поля */
      setFlatNumber({
        flatNumber: undefined
      });
      setRooms({
        roomsCount: undefined
      });
      setArea({
        area: undefined
      });
      getFlatAreasSuggest(params.title);
    } else if (estimationTarget === _.EEstimationTargets.newbuilding) {
      setNewbuildingId({
        newbuildingId: params.id
      });
    }
  };
};
exports.useHandleSuggestItemClick = useHandleSuggestItemClick;